import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgHeart(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22.9406 6.31061C20.7531 5.98435 18.2619 6.98681 17.0536 8.87931C16.8239 9.23895 16.4267 9.45661 16 9.45661C15.5733 9.45661 15.1761 9.23895 14.9464 8.87931C13.7381 6.98681 11.2469 5.98435 9.0594 6.31062C7.99581 6.46925 7.06439 6.93447 6.39779 7.70372C5.7365 8.46683 5.25 9.62836 5.25 11.3388C5.25 14.8469 6.76863 17.6353 8.97758 19.9976C11.0183 22.18 13.5896 23.9376 16 25.5094C18.4104 23.9376 20.9817 22.18 23.0224 19.9976C25.2314 17.6353 26.75 14.8469 26.75 11.3388C26.75 9.62835 26.2635 8.46683 25.6022 7.70372C24.9356 6.93447 24.0042 6.46925 22.9406 6.31061ZM27.4915 6.06651C28.6115 7.35893 29.25 9.13389 29.25 11.3388C29.25 15.6613 27.3492 19.0308 24.8484 21.7051C22.3727 24.3527 19.2425 26.3879 16.6799 28.049C16.2663 28.3171 15.7337 28.3171 15.3201 28.049C12.7575 26.3879 9.62728 24.3527 7.15155 21.7051C4.65079 19.0308 2.75 15.6613 2.75 11.3388C2.75 9.1339 3.3885 7.35893 4.50846 6.06651C5.62311 4.78022 7.12919 4.07085 8.6906 3.83797C11.2318 3.45894 14.0803 4.3217 16 6.22951C17.9197 4.3217 20.7682 3.45894 23.3094 3.83797C24.8708 4.07085 26.3769 4.78022 27.4915 6.06651Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHeart);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
